import { useUser } from "@vivid/react-oidc-client";
import { Route } from "react-router";

import { filterPagesByRoleRecursive } from "./pages/filter";
import { type PageInterface } from "./pages/page.interface";

const DynamicRoute = (page: PageInterface) => {
    if (page.childPages !== undefined) {
        return (
            <Route path={page.routeProps.path} exact={page.routeProps.exact}>
                {page.childPages.map((child) => (
                    <DynamicRoute key={child.routeProps.path} {...child} />
                ))}
            </Route>
        );
    } else {
        if (page.routeProps.component !== undefined) {
            return <Route path={page.routeProps.path} component={page.routeProps.component} exact={page.routeProps.exact} />;
        }
    }

    return null;
};

export const FilteredRoutes = () => {
    const user = useUser();

    return (
        <>
            {user && (
                <>
                    {filterPagesByRoleRecursive(user).map((page) => (
                        <DynamicRoute key={page.routeProps.path} {...page} />
                    ))}
                </>
            )}
        </>
    );
};
